import React from "react";
import { ArrowUpRight } from "lucide-react";

type PillButtonProps = {
  label?: string;
  onClick?: () => void;
  pillColor?: string; // background of main pill
  pillHoverColor?: string; // hover color for main pill
  iconBgColor?: string; // background of icon circle
  iconColor?: string; // arrow color
};

const styles: { [key: string]: React.CSSProperties } = {
  pillButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    padding: "10px 20px",
    fontSize: "14px",
    fontFamily: "Arial, sans-serif",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  pillLabel: {
    flex: 1,
  },
  pillIcon: {
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const PillButton: React.FC<PillButtonProps> = ({
  label = "Start Your Fundraiser",
  onClick,
  pillColor = "#065f46", // default dark green
  pillHoverColor = "#047857", // default hover green
  iconBgColor = "#d9ff46", // default lime
  iconColor = "#000", // default black arrow
}) => {
  const [hover, setHover] = React.useState(false);

  return (
    <button
      onClick={onClick}
      style={{
        ...styles.pillButton,
        backgroundColor: hover ? pillHoverColor : pillColor,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <span style={styles.pillLabel}>{label}</span>
      <span style={{ ...styles.pillIcon, backgroundColor: iconBgColor }}>
        <ArrowUpRight size={16} color={iconColor} />
      </span>
    </button>
  );
};

export default PillButton;
